import { fetchBaseQuery } from '@reduxjs/toolkit/query';
import { stringify } from 'qs';

import { EFeatureFlags } from '@/shared/consts';
import { checkIsFlagEnabled } from '@/shared/helpers';

export const baseQuery = ({
  baseUrl,
  shouldIncludeCredentials = false,
}: {
  baseUrl: string;
  shouldIncludeCredentials?: boolean;
}) =>
  fetchBaseQuery({
    baseUrl,
    paramsSerializer: (params) => {
      if (params instanceof URLSearchParams) {
        return params.toString();
      }

      return stringify(params, {
        arrayFormat: 'brackets',
        skipNulls: true,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        filter: (_, value) => value || undefined,
      });
    },
    prepareHeaders: (headers) => {
      headers.set('Content-Type', 'application/json');
      headers.set('Accept-Language', 'ru');

      return headers;
    },
    fetchFn: (input, init) => {
      if (checkIsFlagEnabled(EFeatureFlags.FetchCredentials) && shouldIncludeCredentials) {
        return fetch(input, { ...init, credentials: 'include' });
      }

      return fetch(input, init);
    },
  });
